<!-- 
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
-->

<template>
  <v-container fluid class="pa-0">
    <v-row no-gutters>
      <v-col>
        <v-btn-toggle v-model="statusses" dense multiple style="width: 100%;">
          <v-btn style="flex: 1" :value=1>
            <v-icon color="green">mdi-square-rounded</v-icon>
          </v-btn>
          <v-btn style="flex: 1" :value=4>
            <v-icon color="blue">mdi-square-rounded</v-icon>
          </v-btn>
          <v-btn style="flex: 1" :value=5>
            <v-icon color="red">mdi-square-rounded</v-icon>
          </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col>
        <v-autocomplete :value="value" :items="items" item-text="name" item-value="id" persistent-hint single-line
          return-object small-chips deletable-chips :label="language.t('FormFields.TaskSelect.chooseTask')"
          :menu-props="{ dense: true }" :search-input.sync="search" :filter="() => { return true }" v-bind="$attrs"
          v-on="listners">

          <!-- <template v-slot:selection="{ item }">
            <v-chip class="truncate-chip" small>
              {{ item.name }}
            </v-chip>
          </template> -->

          <template v-slot:item="data" dense>
            <!-- LOADING TEMPLATE FOR TASK -->
            <template v-if="data.item.isTaskIntersect">
              <v-list-item-content>
                <v-progress-circular indeterminate></v-progress-circular>
                <div v-intersect="endTaskIntersect" />
              </v-list-item-content>
            </template>
            <!-- TEMPLATE FOR TASK -->
            <v-list-item v-if="data.item.isTask" dense class="mx-n4">
              <v-list-item-avatar size="32">
                <v-icon :color="data.item.color">
                  {{ data.item.icon }}
                </v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  {{ data.item.name }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ data.item.date }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Task from "../../models/Task";
import moment from "moment";

export default {
  inheritsAttrs: false,
  data: () => ({
    taskIntersect: { id: "taskIntersect", name: "", isTaskIntersect: true, disabled: true },

    tasks: [],
    items: [{ id: "taskIntersect", name: "", isTaskIntersect: true, disabled: true }],
    value: [],
    selection: [],
    nextTaskPage: null,

    search: null,
    searchTimeout: null,
    statusses: [1],
  }),
  props: {
  },
  watch: {
    statusses() {
      this.resetTaskList()
    },
    search() {
      this.debouncedSearch()
    },
  },
  computed: {
    listners() {
      return {
        ...this.$listners,
        input: event =>
          this.$emit('input', event)
      }
    }
  },
  methods: {
    debouncedSearch() {
      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {

        this.resetTaskList()
      }, 250);
    },
    resetTaskList() {
      console.log("reset tasklist")
      if (this.taskCancel) {
        this.taskCancel.cancel();
      }
      this.tasks = []
      this.items = [];
      this.nextTaskPage = null;

      this.$nextTick(() => {
        this.items = [this.taskIntersect];
      });
    },
    endTaskIntersect(entries, observer, isIntersecting) {
      if (isIntersecting) {
        this.getTasks(true)
      }
    },
    setItems() {
      const tempItems = [];
      this.tasks.forEach(task => {
        /**
         * date: moment.utc(task.edited).local().format("YYYY-MM-DD HH:mm"),
         * unix: moment.utc(task.edited).format("X"),
         * icon: Task.getTaskIcon(task.operationPractice),
         * color: Task.getTaskColor(task.status),
         */
        tempItems.push({
          id: task.taskId,
          name: task.name,
          date: moment.utc(task.edited).local().format("YYYY-MM-DD HH:mm"),
          icon: Task.getTaskIcon(task.operationPractice),
          color: Task.getTaskColor(task.status),
          isTask: true
        })
      });
      tempItems.push(this.taskIntersect)

      console.log(tempItems)


      this.items = [...tempItems];
    },
    getTasks(next_page = false) {
      const page = (next_page && this.nextTaskPage) ? "?page=" + this.nextTaskPage : "?page=1"
      var params = page //+ this.getRequestParams()

      // Filter
      if (this.search) {
        params += "&filter=" + this.search
      }

      if (this.statusses.length > 0) {
        params += "&status="
        params += this.statusses.toString()
      }

      this.taskCancel = this.$axios.CancelToken.source();
      this.$axios
        .get(route("api.tasks.paginate") + params, {
          cancelToken: this.taskCancel.token,
        })
        .then((res) => {
          console.log(res)
          if (res.data.data.length == 0) {
            this.items = []
            this.tasks = [];
            return
          }

          if (this.tasks.length > 0) {
            this.tasks = [...this.tasks, ...res.data.data];
          } else {
            this.tasks = res.data.data
          }

          if (res.data.next_page_url) {
            this.nextTaskPage = res.data.current_page + 1;
          } else {
            this.nextTaskPage = null
          }

          this.setItems()
        })
        .catch((err) => {
          console.log(err);
        });
    },
  }
};
</script>
<style scoped>
.truncate-chip {
  max-width: 120px;
  /* Adjust as needed */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>